export default class Vector {
  x

  y

  constructor({ x, y } = { x: 0.0, y: 0.0 }) {
    this.x = x
    this.y = y
  }

  min(v) {
    return new Vector({ x: Math.min(this.x, v.x), y: Math.min(this.y, v.y) })
  }

  max(v) {
    return new Vector({ x: Math.max(this.x, v.x), y: Math.max(this.y, v.y) })
  }

  clamp(v1, v2) {
    return this.max(v1).min(v2)
  }

  static toArrays(vectors) {
    return vectors.map((v) => v.toArray())
  }

  add(v) {
    return new Vector({ x: this.x + v.x, y: this.y + v.y })
  }

  sub(v) {
    return new Vector({ x: this.x - v.x, y: this.y - v.y })
  }

  scale(x, y = x) {
    return new Vector({ x: x * this.x, y: y * this.y })
  }

  interpolate(v, t) {
    return new Vector({
      x: this.x + (v.x - this.x) * t,
      y: this.y + (v.y - this.y) * t,
    })
  }

  normalize() {
    const l = this.length()

    return new Vector(l > 0 ? { x: this.x / l, y: this.y / l } : {})
  }

  midpoint(v) {
    return this.interpolate(v, 0.5)
  }

  move(distance, angle = 0.0) {
    return new Vector({
      x: this.x + Math.cos((angle * Math.PI) / 180.0) * distance,
      y: this.y - Math.sin((angle * Math.PI) / 180.0) * distance,
    })
  }

  distance(v) {
    return this.sub(v).length()
  }

  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y)
  }

  toArray() {
    return [this.x, this.y]
  }

  toObject() {
    return { x: this.x, y: this.y }
  }
}
